/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './survey-option-group.reducer';

export const SurveyOptionGroupDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const surveyOptionGroupEntity = useAppSelector(state => state.surveyOptionGroup.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="surveyOptionGroupDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.surveyOptionGroup.detail.title">SurveyOptionGroup</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.surveyOptionGroup.id">Id</Translate>
            </span>
          </dt>
          <dd>{surveyOptionGroupEntity.id}</dd>
          <dt>
            <span id="optionGroupName">
              <Translate contentKey="tinyMedicRestApp.surveyOptionGroup.optionGroupName">Option Group Name</Translate>
            </span>
          </dt>
          <dd>{surveyOptionGroupEntity.optionGroupName}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.surveyOptionGroup.active">Active</Translate>
            </span>
          </dt>
          <dd>{surveyOptionGroupEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.surveyOptionGroup.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{surveyOptionGroupEntity.cursor}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.surveyOptionGroup.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{surveyOptionGroupEntity.lastupdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.surveyOptionGroup.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{surveyOptionGroupEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.surveyOptionGroup.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{surveyOptionGroupEntity.timestampentry}</dd>
        </dl>
        <Button tag={Link} to="/survey-option-group" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/survey-option-group/${surveyOptionGroupEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default SurveyOptionGroupDetail;
